export const useColors = () => {
    const getCalificationColorWithAlfa = (calificacion, alfa) => {
        if (calificacion === 'A')
            return "rgba(38, 146, 61," + alfa + ")"
        else if (calificacion === 'B')
            return "rgba(152, 203, 50," + alfa + ")"
        else if (calificacion === 'C')
            return "rgba(246, 175, 31," + alfa + ")"
        else if (calificacion === 'D')
            return "rgba(230, 25, 25," + alfa + ")"
    }
    const getCalificationColor = (calificacion) => {
       return getCalificationColorWithAlfa(calificacion, 1)
    }
    return { getCalificationColorWithAlfa, getCalificationColor };
}
